// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607280913/js/" + chunkId + "." + {"44":"5f87b00f","225":"acbd1366","481":"a06a202a","486":"957c018c","770":"36341de8"}[chunkId] + ".0.30146702928509495.chunk.js";
};